import request from "@/utils/request";

export function searchPage(keyword, pageNum = 1, pageSize = 10) {
  return request.get("/api/search/page", {
    params: {
      keyword,
      pageNum,
      pageSize,
    },
  });
}
